import { Controller } from "@hotwired/stimulus"

// Adds operating hours rows. Template uses NEW_RECORD_INDEX as child_index (replaced with timestamp).
export default class extends Controller {
  static targets = ["container", "template"]

  static values = {
    maxRows: { type: Number, default: 7 }
  }

  add(event) {
    event.preventDefault()

    const currentCount = this.containerTarget.querySelectorAll("[data-controller*='operating-hours-closed-sync']").length
    if (currentCount >= this.maxRowsValue) return

    const templateContent = this.templateTarget.innerHTML
    const index = Date.now()
    const newRowHtml = templateContent.replace(/NEW_RECORD_INDEX/g, index)

    this.containerTarget.insertAdjacentHTML("beforeend", newRowHtml)
  }
}
